module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_link_image_item-7e27d5cd20cd04ac008f8a07e5077252.jpg";